import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBase } from './api.base';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { IUserDTO } from '../dto/user-dto';

@Injectable()
export class UsersApi extends ApiBase {

  constructor(http: HttpClient) {
    super(http, 'users');
  }

  getCurrent(): Observable<IUserDTO> {
    return this.doGet('current');
  }

  updateCurrent(item: any): Observable<IUserDTO> {
    return this.doPut('current', item);
  }
}
